var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("section", { staticClass: "browse-search", class: _vm.className }, [
    _vm.mode === "default" || _vm.mode === "browse"
      ? _c(
          "div",
          { staticClass: "browse-search__section browse-search__browse-form" },
          [
            _c("BrowseForm", {
              attrs: {
                mode: _vm.mode,
                nbResults: _vm.nbResults,
                routeName: _vm.routeName,
                industry: _vm.industry,
                industryOptions: _vm.industryOptions,
                sector: _vm.sector,
                sectorOptions: _vm.sectorOptions,
                category: _vm.category,
                categoryOptions: _vm.categoryOptions,
                industryLoading: _vm.industryLoading,
                sectorLoading: _vm.sectorLoading,
                categoryLoading: _vm.categoryLoading,
                submit: _vm.browseSubmit,
                industryChange: _vm.updateIndustry,
                sectorChange: _vm.updateSector,
                categoryChange: _vm.updateCategory,
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.mode === "default"
      ? _c(
          "div",
          { staticClass: "browse-search__section browse-search__separator" },
          [_c("h3", [_vm._v("Or")])]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.mode === "default" || _vm.mode === "search"
      ? _c(
          "div",
          { staticClass: "browse-search__section browse-search__search-form" },
          [
            _c("SearchForm", {
              attrs: {
                mode: _vm.mode,
                term: _vm.term,
                nbResults: _vm.nbResults,
                submit: _vm.searchSubmit,
                helpForSearchTerm: _vm.helpForSearchTerm,
              },
            }),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }